/**
 * Copyright Han Lee <hanlee.dev@gmail.com> and other contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { BaseControl } from './base'

export enum ColumnType {
  Normal,
  Parallel,
  Justify,
}

export enum ColumnDirection {
  Left,
  Right,
  Justify,
}

export default class ColumnControl implements BaseControl {
  id: number = 0

  type: ColumnType = ColumnType.Normal

  count: number = 0

  direction: ColumnDirection = ColumnDirection.Left

  isSameWidth: boolean = true

  gap: number = 0

  widths: number[] = []

  borderStyle: number = 0

  borderWidth: number = 0

  borderColor: number = 0
}
